module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("\n      Shopping Cart\n    ")]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', {
    staticClass: "empty-cart"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("\n        🛒\n      ")]), _vm._v(" "), _c('h2', [_vm._v("Your cart is empty")]), _vm._v(" "), _c('p', [_vm._v("Add some items from our shop to get started!")]), _vm._v(" "), _c('button', {
    staticClass: "btn-continue-shopping",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n        Continue Shopping\n      ")])]) : _c('div', {
    staticClass: "cart-content"
  }, [_c('div', {
    staticClass: "cart-items"
  }, _vm._l((_vm.cart), function(item) {
    return _c('div', {
      key: item.variantId,
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(item.image) ? _c('img', {
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("\n              No Image\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-details"
    }, [_c('h3', {
      staticClass: "item-name"
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "item-variants"
    }, [(item.color) ? _c('span', {
      staticClass: "variant-badge"
    }, [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', {
      staticClass: "variant-badge"
    }, [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-price"
    }, [(item.isOnSale) ? _c('span', {
      staticClass: "sale-indicator"
    }, [_vm._v("SALE")]) : _vm._e(), _vm._v("\n              $" + _vm._s(_vm.formatPrice(item.price)) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-actions"
    }, [_c('div', {
      staticClass: "quantity-control"
    }, [_c('button', {
      attrs: {
        "disabled": item.quantity <= 1
      },
      on: {
        "click": function($event) {
          _vm.decrementQuantity(item)
        }
      }
    }, [_vm._v("\n                -\n              ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.quantity),
        expression: "item.quantity",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": _vm._s(item.quantity)
      },
      on: {
        "change": function($event) {
          _vm.updateQuantity(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.quantity = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.incrementQuantity(item)
        }
      }
    }, [_vm._v("\n                +\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-total"
    }, [_vm._v("\n              $" + _vm._s(_vm.formatPrice(item.price * item.quantity)) + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-remove",
      attrs: {
        "title": "Remove item"
      },
      on: {
        "click": function($event) {
          _vm.removeItem(item)
        }
      }
    }, [_vm._v("\n              ×\n            ")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "cart-summary"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal (" + _vm._s(_vm.cartItemCount) + " items)")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), (_vm.isAuthenticated) ? _c('button', {
    staticClass: "btn-checkout",
    on: {
      "click": function($event) {
        _vm.$router.push('/checkout')
      }
    }
  }, [_vm._v("\n            Proceed to Checkout\n          ")]) : _c('button', {
    staticClass: "btn-login",
    on: {
      "click": function($event) {
        _vm.$router.push('/register')
      }
    }
  }, [_vm._v("\n            Login to Checkout\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-continue-shopping",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n            Continue Shopping\n          ")]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('div', {
    staticClass: "auth-notice"
  }, [_vm._v("\n            Please login to complete your purchase.\n          ")]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-456c9b9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cart.vue
// module id = 496
// module chunks = 1